/* tslint:disable */
require('./FieldBaseTextRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_3cccbd2b',
  relative: 'relative_3cccbd2b',
  baseText: 'baseText_3cccbd2b',
  fabricIcon: 'fabricIcon_3cccbd2b',
};

export default styles;
/* tslint:enable */